<template>
  <HeaderMobileComponent :showHeader="windowWidth<768" />
  <HeaderComponent :showHeader="windowWidth>=768" />
  <div class="my-container main_section layout_main_section h-full w-full">
    <main class="w-full h-full bg-[#f5f5f5]">
      <slot />
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from '@/components/HeaderComponent.vue';
import HeaderMobileComponent from '@/components/HeaderMobileComponent.vue';

export default {
  name: 'WebLayout',
    components: {
      HeaderComponent,
      FooterComponent,
      HeaderMobileComponent,
    },
    data() {
      return {
        windowWidth: window.innerWidth,
      };
    },
};
</script>
